module.exports = __webpack_public_path__ + "img/icon-diagnosis.7ebc26cd.svg";